import Vue from 'vue';
import router from '../router';
import VueGtag from 'vue-gtag';
import getEnvVar from 'helper/envHelper';

Vue.use(
  VueGtag,
  {
    config: {
      id: getEnvVar('GOOGLE_ANALYTICS_ID'), //G-NNEJ4XXWSP
      params: {
        send_page_view: false,
      },
    },
  },
  router
);
